import React from "react";

export default function Messaging() {
  return <div>Messaging</div>;
}
